export const apiErrorHelper = () => {
    
    const handleApiError = (error) => {
        if (!error) {
            return "Si è verificato un errore sconosciuto.";
        }

        // Prova a estrarre lo status code da diverse posizioni
        const statusCode = retriveErrorStatusCode(error)

        // Mappa dei messaggi per status code comuni
        const statusMessages = {
            400: "Richiesta non valida, Controlla i dati inviati.",
            401: "Non sei autorizzato ad effettuare questa operazione.",
            403: "Accesso negato, Non hai i permessi necessari.",
            404: "Risorsa non trovata, Riprova più tardi.",
            409: "conflitto, La risorsa esiste già o è in conflitto con i dati esistenti.",
            422: "Dati non validi, Verifica i campi richiesti.",
            500: "Errore interno del server, Riprova più tardi.",
            503: "Servizio non disponibile, Riprova più tardi.",
        };

        if (statusCode && statusMessages[statusCode]) {
            return statusMessages[statusCode];
        }

        // Fallback: usa il messaggio originale se disponibile
        if (error.message) {
            return `Errore: ${error.message}`;
        }

        // Fallback generico
        return "Si è verificato un errore. Riprova più tardi.";
    };
    const retriveErrorStatusCode = (error) => {
        const statusCode =
            error.originalError?.extensions?.internal?.response?.status ||
            error.originalError?.extensions?.internal?.status ||
            error.extensions?.internal?.response?.status ||
            error.extensions?.internal?.status ||
            null;
        return statusCode;
    }

    return {
        handleApiError,
        retriveErrorStatusCode
    };
};
